// Need to use the React-specific entry point to import createApi
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
// import { getApiUrl } from "utils";
import { API_URL } from "constants/api";

// Define a service using a base URL and expected endpoints
export const transactionApi = createApi({
  reducerPath: "transactions",
  baseQuery: fetchBaseQuery({ baseUrl: API_URL }),
  endpoints: (builder) => ({
    getTransactionList: builder.query<
      any,
      { offset: number; limit: number; address?: string }
    >({
      query: ({ address, offset, limit }) =>
        `transaction/lastest?offset=${offset}&limit=${limit}${
          address ? `&address=${address}` : ""
        }`,
    }),
    getTransactionDetail: builder.query<any, string>({
      query: (hash) => `transaction?hash=${hash}`,
      keepUnusedDataFor: 0,
    }),
    getTxStatus: builder.query<any, string>({
      query: (hash) => `transaction/txstatus?hash=${hash}`,
    }),
    getSolTxs: builder.query<any, string>({
      query: (hash) => `transaction/soltx?hash=${hash}`,
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetTransactionListQuery,
  useGetTransactionDetailQuery,
  useGetSolTxsQuery,
  useGetTxStatusQuery,
} = transactionApi;
